/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { OasSchemaFactory } from '../../core/factories/OasSchemaFactory';
import { Document } from '../../core/models/Document';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SchemaDefinition } from '../../openapi/v3/models/Oas30SchemaDefinition';
import { NewSchemaDefinitionCommand } from './NewSchemaDefinitionCommand';
import { Oas30Components } from '../../openapi/v3/models/Oas30Components';
import { IDefinition } from '../../core/models/common/IDefinition';

/**
 * @author eric.wittmann@gmail.com
 * @extends NewSchemaDefinitionCommand
 * @class
 */
export class NewSchemaDefinitionCommand_30 extends NewSchemaDefinitionCommand {
    public _nullComponents : boolean;

    public constructor(definitionName? : any, example? : any, description? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((example != null) || example === null) && ((typeof description === 'string') || description === null)) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
            (() => {
                this._newDefinitionName = definitionName;
                this._newDefinitionExample = example;
                this._newDefinitionDescription = description;
            })();
        } else if(definitionName === undefined && example === undefined && description === undefined) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewDefinitionCommand] Executing.");
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this.isNullOrUndefined(doc30.components)) {
            doc30.components = doc30.createComponents();
            this._nullComponents = true;
        }
        this._nullComponents = false;
        if(this.isNullOrUndefined(doc30.components.getSchemaDefinition(this._newDefinitionName))) {
            let definition : Oas30SchemaDefinition;
            if(!this.isNullOrUndefined(this._newDefinitionExample)) {
                definition = <Oas30SchemaDefinition><any>OasSchemaFactory.createSchemaDefinitionFromExample(doc30, this._newDefinitionName, this._newDefinitionExample);
                definition.example = this._newDefinitionExample;
            } else {
                definition = doc30.components.createSchemaDefinition(this._newDefinitionName);
                definition.type = "object";
            }
            if(ModelUtils.isDefined(this._newDefinitionDescription)) {
                definition.description = this._newDefinitionDescription;
            }
            doc30.components.addSchemaDefinition(this._newDefinitionName, definition);
            this._defExisted = false;
        } else {
            this._defExisted = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewDefinitionCommand] Reverting.");
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this._nullComponents) {
            doc30.components = null;
        }
        if(this._defExisted) {
            return;
        }
        doc30.components.removeSchemaDefinition(this._newDefinitionName);
    }
}
NewSchemaDefinitionCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.NewSchemaDefinitionCommand_30";
NewSchemaDefinitionCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




